




























































































































import { Component, PropSync, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { MessageService } from "@/shared/services/message-service";
import { ProcessoNums, getTexto } from "./ProcessoNums";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import { datos_adicionales_producto } from "@/shared/dtos/datos_adicionales_producto";
@Component({
  components: {
    ConfirmDialog,
  },
})
export default class ProcesoVenta extends Vue {
  @PropSync("id", { default: -1 }) id_prodcuto!: number;
  @PropSync("show", { default: false }) Xshow!: boolean;
  show_proceso: boolean = false;
  public selectedRow: producto = new producto();
  public productosiguales: number = 0;

  public cards = [
    { text: "EFECTIVO", icon: "fas fa-money-bill", id: 1 },
    { text: "TARJETA", icon: "fal fa-credit-card", id: 2 },
  ];
  public tipo_venta: number = 0;

  async created() {
    if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
      this.cards = this.cards.filter((card) => card.text !== "EFECTIVO");
      //venta en tarjeta de manera automatica
      this.onCardClick(this.cards[0], 0);
    }
    if (!(productoModule.productos.length > 0)) {
      await productoModule.getproductos();
    }
    this.selectedRow = productoModule.productos.find(
      (x) => x.id === this.id_prodcuto
    )!;

    await datos_adicionales_productoModule.getdatos_adicionales_productoById(
      this.selectedRow.id
    );
    this.productosiguales =
      productoModule.productos.filter(
        (x) => x.asin === this.selectedRow.asin && x.vendido == false
      )!.length - 1;
  }

  get _datos_adicionales() {
    return datos_adicionales_productoModule.datos_adicionales_producto;
  }

  get Ganacias() {
    return (
      this.selectedRow.precio_vendido - this.selectedRow.coste_compra
    ).toFixed(2);
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  onCardClick(action: any, index: any) {
    switch (action.id) {
      case 1:
        this.tipo_venta = ProcessoNums.VendidoEfectivo;
        break;
      case 2:
        this.tipo_venta = ProcessoNums.VendidoTarjeta;
        break;
      default:
        break;
    }
    this.show_proceso = true;
  }
  estadoTemplate(rowData: any) {
    return getTexto(rowData);
  }
  aceptar() {
    this.selectedRow.estado = this.tipo_venta;
    this.selectedRow.vendido = true;
    this.selectedRow.fecha_venta = new Date();
    datos_adicionales_productoModule.eliminardatos_adicionales_producto(
      this._datos_adicionales
    );

    productoModule.venderproducto(this.selectedRow).then(() => {
      this.cancelar();
      MessageService.toast("Vendido, Ahora está en el historial de productos");
      productoModule.getproductos();
    });
  }
  cancelar() {
    this.Xshow = false;
    this.show_proceso = false;
  }
}
